module.exports = __webpack_public_path__ + "img/group_add.83a9cfee.svg";